import { lazy, Suspense, useEffect, useState } from "react";
import { Navigate, Outlet, Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { getToken, setToken } from "./api";
import { AppLayout } from "./components/AppLayout";
import { Login } from "./pages/Login";

const Dashboard = lazy(() => import("./pages/Dashboard").then((module) => ({ default: module.Dashboard })));
const UploadAnalysis = lazy(() => import("./pages/UploadAnalysis").then((module) => ({ default: module.UploadAnalysis })));
const Cases = lazy(() => import("./pages/Cases").then((module) => ({ default: module.Cases })));
const CaseDetail = lazy(() => import("./pages/CaseDetail").then((module) => ({ default: module.CaseDetail })));
const Knowledge = lazy(() => import("./pages/Knowledge").then((module) => ({ default: module.Knowledge })));
const KnowledgeAsk = lazy(() => import("./pages/KnowledgeAsk").then((module) => ({ default: module.KnowledgeAsk })));
const Team = lazy(() => import("./pages/Team").then((module) => ({ default: module.Team })));
const Settings = lazy(() => import("./pages/Settings").then((module) => ({ default: module.Settings })));

function Protected({ authenticated }: { authenticated: boolean }) {
  const location = useLocation();
  return authenticated ? <Outlet /> : <Navigate to="/login" replace state={{ from: location.pathname }} />;
}

export default function App() {
  const [authenticated, setAuthenticated] = useState(Boolean(getToken()));
  const navigate = useNavigate();
  useEffect(() => {
    const onStorage = () => setAuthenticated(Boolean(getToken()));
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, []);

  return <Suspense fallback={<div className="page-loading">正在加载</div>}><Routes>
    <Route path="/login" element={<Login onLogin={() => { setAuthenticated(true); navigate("/"); }} />} />
    <Route element={<Protected authenticated={authenticated} />}>
      <Route element={<AppLayout onLogout={() => { setToken(null); setAuthenticated(false); navigate("/login"); }} />}>
        <Route index element={<Dashboard />} />
        <Route path="upload" element={<UploadAnalysis />} />
        <Route path="cases" element={<Cases />} />
        <Route path="cases/:id" element={<CaseDetail />} />
        <Route path="knowledge" element={<Knowledge />} />
        <Route path="knowledge-ask" element={<KnowledgeAsk />} />
        <Route path="team" element={<Team />} />
        <Route path="settings" element={<Settings />} />
      </Route>
    </Route>
    <Route path="*" element={<Navigate to="/" replace />} />
  </Routes></Suspense>;
}
